"use client";
import { useState, useCallback } from "react";

import { showErrorToast } from "@stadium/services/react-toastify";
import { snakifyKeys } from "@stadium/helpers/src/formatter";

import { updateOrderDetails, updateUserTreat } from "@stadium/checkout/src/api/order";
import { SM_PROGRAM_IDENTIFIER } from "@stadium/constants";

const emptyObj = {};

const useUpdateOrder = ({
  orderId,
  orderNumber,
  orderResponseType,
  shouldUpdateTreat = false,
  giftDetailAttributes = {},
  additionalOrderParams = {},
  setOrderData = () => {},
}) => {
  const [loading, setLoading] = useState(false);

  const updateOrderPromise = (data) =>
    shouldUpdateTreat
      ? updateUserTreat({ number: orderNumber, data, additionalOrderParams })
      : updateOrderDetails({
          orderId,
          orderData: data,
          responseType: orderResponseType,
          additionalOrderParams,
        });

  const updateOrder = useCallback(
    (data, callback = () => emptyObj) => {
      if (!orderId) return;

      setLoading(true);
      updateOrderPromise({
        program_id: SM_PROGRAM_IDENTIFIER,
        ...snakifyKeys(data),
        ...giftDetailAttributes,
      })
        .then((response) => {
          callback(response);
          setOrderData(response);
        })
        .catch(() => {
          setLoading(false);
          showErrorToast();
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [orderId, giftDetailAttributes],
  );

  return { loading, updateOrder };
};

export default useUpdateOrder;
